import { getStateCodeByZipcode } from './zipcode';
import { InsurancePlan } from 'src/services/interfaces/insurance';

// Resolve the user's 2-letter state. Zip (collected on the personal info step)
// is the source of truth; fall back to an explicit address.state if present.
export const resolveUserState = (
  zipcode?: string | null,
  state?: string | null
): string | null => {
  if (zipcode && /^\d{5}$/.test(zipcode)) {
    const fromZip = getStateCodeByZipcode(zipcode);
    if (fromZip) return fromZip;
  }
  return state || null;
};

// A plan is available unless the user's state is listed in its forbiddenStates.
// Unknown state -> don't hide anything (the user can't have reached a plan step
// without a zip, but stay permissive just in case).
export const isPlanAvailableInState = (
  plan: Pick<InsurancePlan, 'forbiddenStates'>,
  state?: string | null
): boolean => {
  if (!state) return true;
  return !(
    Array.isArray(plan.forbiddenStates) && plan.forbiddenStates.includes(state)
  );
};
